import { useUser } from "./useUser";

type ClientAccountWithEntitledRegions = {
  entitled_regions?: readonly ("CA" | "UK" | "AU")[];
};

export function useEntitledRegions() {
  const { details } = useUser();
  const clientAccount = details?.client_account as
    | ClientAccountWithEntitledRegions
    | undefined;

  return {
    canSwitchRegion: (clientAccount?.entitled_regions?.length ?? 0) > 1,
  };
}
